import { Component, OnInit, ViewChild, ElementRef, } from '@angular/core';
import { AlertController, LoadingController, PopoverController, ToastController } from '@ionic/angular';

import * as fileUpload from 'fuctbase64';
import { NgxImageCompressService } from 'ngx-image-compress-legacy';
import { FotosService } from 'src/app/servicios/fotos/fotos.service';
import { ImagenesService } from 'src/app/servicios/imagenes.service';
import { CONFIGURATIONS } from 'src/constant/constantes';


//let fileUpload = require ('fuctbase64');
//import * as Loader from "babylonjs-loaders";
@Component({
  selector: 'app-fotos',
  templateUrl: './fotos.component.html',
  styleUrls: ['./fotos.component.scss'],
})

export class FotosComponent implements OnInit {
  //@ViewChild("canvas") canvas: ElementRef;
  sliderOpts = {
    zoom: { maxRatio: 2 }
  };
  constructor(public alertCtrl: AlertController, public fotosService: FotosService,
    public poper: PopoverController, public loadingController: LoadingController,
    public imagenesService: ImagenesService, private toastController: ToastController,
    private imageCompress: NgxImageCompressService) {
    this.fotoFuera64 = this.imagenesService.imagenFotoFuera();
    this.fotosFuera = fotosService.fotosfuera;
    this.calcularPrecioFotos()
  }
  json = [];

  ngOnInit() {

  }

  fotoFuera64;
  file;
  arrayBuffer;
  imageData;

  precioTotal = 0;
  configuracion = CONFIGURATIONS;
  image;

  calcularPrecioFotos() {
    let cantidad = this.fotosFuera.length;
    this.precioTotal = this.configuracion.precioPorFoto * cantidad;
  }


  localUrl: any;
  localCompressedURl: any;
  sizeOfOriginalImage: number;
  sizeOFCompressedImage: number;
  changeListener($event: any): void {
    fileUpload($event)
      .then((data) => {
        this.compressFile(data, data.name)
      })
  }

  imgResultAfterCompress: string;
  async compressFile(image, fileName) {
    const loading = await this.loadingController.create({
      message: "ʕ•́ᴥ•̀ʔっ"
    });
    await loading.present();

    var orientation = -1;
    this.sizeOfOriginalImage = this.imageCompress.byteCount(image) / (1024 * 1024);
    this.imageCompress.compressFile("data:image/jpeg;base64," + image.base64, orientation, 35, 35).then(
      (result: any) => {
        this.imgResultAfterCompress = result;
        this.localCompressedURl = result;
        this.sizeOFCompressedImage = this.imageCompress.byteCount(result) / (1024 * 1024)
        this.fotosService.agregarFotoFuera(this.imgResultAfterCompress);
        this.calcularPrecioFotos();
      }).finally(function(){
        loading.dismiss();
      });
  }

  dataURItoBlob(dataURI) {
    const byteString = window.atob(dataURI);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const int8Array = new Uint8Array(arrayBuffer);
    for (let i = 0; i < byteString.length; i++) {
      int8Array[i] = byteString.charCodeAt(i);
    }
    const blob = new Blob([int8Array], { type: 'image/jpeg' });
    return blob;
  }
  async Alerta(mensaje, submensaje) {
    let ok = "Ok";
    const alert = await this.alertCtrl.create({
      header: mensaje,
      subHeader: submensaje,
      buttons: [
        {
          text: "Entiendo",
          handler: data => console.log("si"),
          role: '',
        },
      ]
    });
    await alert.present();
  }
  foto;
  fotosFuera = [];


  frase(event, i) {
    let Mifrase = event.detail.value;
    this.fotosService.fotosfuera[i].frase = Mifrase;

  }

  deleteImage2(i) {
    this.fotosFuera.splice(i, 1);
    this.calcularPrecioFotos();
  }

  async deleteImage(i) {
    const alert = await this.alertCtrl.create({
      header: "Eliminar foto",
      subHeader: "¿Seguro de eliminar esta fotografía?",
      buttons: [
        {
          text: "Si",
          handler: data => this.deleteImage2(i),
          role: '',
        },
        {
          text: "No",
          handler: data => console.log("ok"),
          role: '',
        },
      ]
    });
    await alert.present();
  }

  async aceptarPopOver() {
    this.poper.dismiss({
    });
  }

  async mostrarToast(color: 'success' | 'danger' | 'warning') {
    const toast = await this.toastController.create({
      message: "¡Bien!, Foto Agregada",
      position: 'bottom',
      duration: 2000,
      color: color
    });
    toast.present();
  }

  async cerarPopOver() {
    this.poper.dismiss();
  }
}
